import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap, FiGrid } = FiIcons;

const Header = () => {
  const location = useLocation();

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed top-0 left-0 right-0 z-50 bg-gray-900/80 backdrop-blur-xl border-b border-cyan-400/20"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-center gap-4 md:gap-8 overflow-x-auto">
          <Link
            to="/"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 whitespace-nowrap ${
              location.pathname === '/'
                ? 'bg-cyan-400/10 text-cyan-400 border border-cyan-400/30'
                : 'text-gray-300 hover:text-cyan-400 hover:bg-cyan-400/5'
            }`}
          >
            <SafeIcon icon={FiZap} className="text-xl" />
            <span className="font-medium">Vidroid</span>
          </Link>

          <Link
            to="/other-models"
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 whitespace-nowrap ${
              location.pathname === '/other-models'
                ? 'bg-purple-400/10 text-purple-400 border border-purple-400/30'
                : 'text-gray-300 hover:text-purple-400 hover:bg-purple-400/5'
            }`}
          >
            <SafeIcon icon={FiGrid} className="text-xl" />
            <span className="font-medium">Other AI Models</span>
          </Link>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;